import React from 'react'
import {StorageProvider} from "./src/context/StorageContext"
export const wrapRootElement = ({element}) => (
    <StorageProvider>{element}</StorageProvider>
)